// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n* Colors\n*/\n.HeaderActions_wrapper__3xBJK {\n  display: flex; }\n  .HeaderActions_wrapper__3xBJK.HeaderActions_inSection__2TESN {\n    position: absolute;\n    top: 32px;\n    right: 38px; }\n\n.HeaderActions_statusDropdown__r2smI .anticon.anticon-down {\n  display: none; }\n\n.HeaderActions_statusDropdownMenu__3QoeR {\n  background-color: transparent !important;\n  box-shadow: none;\n  padding: 0; }\n  .HeaderActions_statusDropdownMenu__3QoeR li {\n    background-color: transparent !important;\n    padding: 0; }\n    .HeaderActions_statusDropdownMenu__3QoeR li > a {\n      padding-top: 0; }\n", ""]);
// Exports
exports.locals = {
	"wrapper": "HeaderActions_wrapper__3xBJK",
	"inSection": "HeaderActions_inSection__2TESN",
	"statusDropdown": "HeaderActions_statusDropdown__r2smI",
	"statusDropdownMenu": "HeaderActions_statusDropdownMenu__3QoeR"
};
module.exports = exports;
